FroalaEditor.DefineIcon('checkbox', { NAME: 'check'});
FroalaEditor.RegisterCommand('checkbox', {
    title: 'Checkbox',
    undo: true,
    focus: true,
    refreshAfterCallback: false,
    callback: function(cmd, source) {
        var newbox = document.createElement('div');
        newbox.innerHTML= "<input type='checkbox' aria-label='checkbox'></input>&nbsp;";
        this.selection.element().appendChild(newbox)
    }
});
